import React from "react";
import GenericListPage from "../../../Domain/Components/Functional/GenericListPage/GenericListPage";

function CampaignListPage(props) {
    return (
        <>
            <GenericListPage setLoggedIn={props.setLoggedIn}
                            detailsHref={"/campaign/details"}
                            objectKeys={["id", "name", "currency.iso_code", "tenant.external_id",  "provider_campaign_id", "contribution_type","contribution_amount", "minimum_bet"]}
                            columnTitles={[
                                "ID", "Name", "Currency", "Tenant",  "Provider Campaign ID", "Contribution Type", "Contribution Amount", "Minimum bet"
                            ]}
                            pageTitle={"Campaigns"}
                            readEndpoint={"campaign/read"}
                            relations={["currency","tenant"]}
                            />
        </>
    )
}

export default CampaignListPage;